<script setup>
import {clampRating} from '~/utils/rating-star.mjs';
const props=defineProps({value:[Number,String],size:{type:[Number,String],default:16},label:String});
const rating=computed(()=>clampRating(props.value));
</script>
<template><span class="uo-rating-stars" role="img" :aria-label="label||('Оценка: '+rating.toLocaleString('ru-RU')+' из 5')"><CommonRatingStar v-for="n in 5" :key="n" :size="size" :fraction="Math.max(0,Math.min(1,rating-n+1))"/></span></template>
<style>.uo-rating-stars{display:inline-flex;align-items:center;gap:2px;vertical-align:middle;white-space:nowrap;background:none!important;-webkit-text-fill-color:initial!important}</style>
